import { useState } from 'react';

import PlayApps from '@crehana/compass.icons.fill/PlayApps';
import { Modal } from '@crehana/compass.ui';
import { Tag } from '@crehana/compass.ui/tag';
import { cn } from '@crehana/compass.ui/utils';
import CrehanaPlayerWrapper from '@crehana/player';

import CoursePromoImage from '../../components/CoursePromoImage';
import { useCourseDetailCourse, useCourseDetailTranslation } from '../../hooks';

const Opacity: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => (
  <div className={cn('tw-bg-[rgba(7, 14, 39, 0.5)]', className)}>
    {children}
  </div>
);

type PlayerProps = {
  isSticky?: boolean;
  className?: string;
};

const Player: React.FC<PlayerProps> = ({ isSticky = false, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useCourseDetailTranslation();
  const { course } = useCourseDetailCourse();

  return (
    <div
      id="course-detail-anchor"
      className={cn(
        'tw-relative tw-w-full tw-transition-[height] tw-duration-500 tw-ease-in-out',
        !isSticky ? 'tw-h-20' : 'tw-h-0',
        className,
      )}
    >
      {!isSticky && (
        <>
          {course.isMandatory && (
            <Tag className="tw-bg-neutral-dark-700 tw-text-neutral-light-100 tw-absolute tw-top-1.6 tw-left-1.6 tw-z-1">
              {t('REQUIRED')}
            </Tag>
          )}
          <CoursePromoImage />
          {course.videoTrailer?.sources ? (
            <button
              type="button"
              className="tw-cursor-pointer"
              onClick={() => setIsOpen(true)}
            >
              <Opacity className="tw-absolute tw-top-0 tw-left-0 tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-z-2">
                <div className="tw-text-neutral-light-100 tw-flex tw-gap-1 tw-items-center">
                  <PlayApps className="tw-fill-current" size={20} />
                  <span className="tw-font-semibold">{t('WATCH_TRAILER')}</span>
                </div>
              </Opacity>
            </button>
          ) : (
            <Opacity className="tw-absolute tw-top-0 tw-left-0 tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-z-2" />
          )}
        </>
      )}

      {isOpen && (
        <Modal
          className="tw-flex tw-justify-center tw-place-items-center"
          role="dialog"
          open={isOpen}
          onDismiss={() => setIsOpen(false)}
        >
          <div className="tw-w-[34rem] sm:tw-w-[56.4rem]">
            <CrehanaPlayerWrapper
              videoId={`video-${course.originalId}`}
              autoplay={true}
              hideLogo={true}
              hiddenNotes={true}
              sources={course.videoTrailer?.sources || []}
              hideSkipButtons
              hideSpeedOptions={true}
              defaultAudioLang={'es'}
              defaultSubtitleLang={'es'}
              orientation="portrait"
            />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Player;
